export default __webpack_public_path__ + "static/media/workflowArtBoard.6c22c392.jpeg";